import React from 'react';
import DatePicker from 'react-datepicker';
import Input from 'components/Common/Forms/Input';
import ReadOnlyField from 'components/Common/ReadOnlyField';

const ToggleableInput = props => {
  const { datePicker, operator, readOnlyContent, readOnly, ...passedProps } =
    props;

  const select = () => {
    if (readOnly) {
      return <ReadOnlyField operator={operator} content={readOnlyContent} />;
    }
    if (datePicker) {
      return <DatePicker customInput={<Input />} {...passedProps} />;
    }
    return <Input title="Input Field" {...passedProps} />;
  };

  return select();
};

export default ToggleableInput;
